import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { Alert, Button, Card, CardBody, Form, Spinner, Table } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Select from "react-select";
import moment from "moment";
import ReportDateRangeSelect, { getReportDateRange } from "layouts/ReportDateRangeSelect";
import { useGlobalModalContext } from "contexts/GlobalModalContext";
import { useAppDispatch, useAppSelector } from "../../redux/store/configureStore";
import { allShop, clearallShop } from "../../redux/handlers/manage/allShop.handler";
import { clearGetReportReservationPerformanceMonthly, getReportReservationPerformanceMonthly } from "../../redux/handlers/report/getReportReservationPerformanceMonthly.handler";
var EMPTY_SUMMARY = {
    sale_confirmed: 0,
    organizing: 0,
    product_checked: 0,
    waiting_delivery: 0,
    delivered: 0
};
var numberText = function(value) {
    return Number(value || 0).toLocaleString("en-US");
};
var countClassName = function(value) {
    return "text-end fw-semibold ".concat(Number(value || 0) > 0 ? "text-success" : "text-danger");
};
export function ReportReservationPerformanceMonthly() {
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var modalContextRef = useRef({
        modalObj: modalObj,
        setModalObj: setModalObj
    });
    var allShopReducer = useAppSelector(function(state) {
        return state.allShopReducer;
    });
    var reportReducer = useAppSelector(function(state) {
        return state.getReportReservationPerformanceMonthlyReducer;
    });
    var _useState = _sliced_to_array(useState(null), 2), startDate = _useState[0], setStartDate = _useState[1];
    var _useState1 = _sliced_to_array(useState(null), 2), endDate = _useState1[0], setEndDate = _useState1[1];
    var _useState2 = _sliced_to_array(useState("custom"), 2), dateRange = _useState2[0], setDateRange = _useState2[1];
    var _useState3 = _sliced_to_array(useState(""), 2), shopId = _useState3[0], setShopId = _useState3[1];
    var _useState4 = _sliced_to_array(useState(""), 2), branchId = _useState4[0], setBranchId = _useState4[1];
    var _useState5 = _sliced_to_array(useState([]), 2), shops = _useState5[0], setShops = _useState5[1];
    var _useState6 = _sliced_to_array(useState([]), 2), rows = _useState6[0], setRows = _useState6[1];
    var _useState7 = _sliced_to_array(useState(EMPTY_SUMMARY), 2), summary = _useState7[0], setSummary = _useState7[1];
    var _useState8 = _sliced_to_array(useState(false), 2), hasSearched = _useState8[0], setHasSearched = _useState8[1];
    var _useState9 = _sliced_to_array(useState(""), 2), error = _useState9[0], setError = _useState9[1];
    var loading = reportReducer.isFetching;
    var loadingFilters = allShopReducer.isFetching;
    useEffect(function() {
        modalContextRef.current = {
            modalObj: modalObj,
            setModalObj: setModalObj
        };
    }, [
        modalObj,
        setModalObj
    ]);
    var clearReport = function() {
        setRows([]);
        setSummary(EMPTY_SUMMARY);
        setHasSearched(false);
        setError("");
    };
    var handleDateRangeChange = function(preset) {
        setDateRange(preset);
        var range = getReportDateRange(preset);
        if (range) {
            setStartDate(range.startDate);
            setEndDate(range.endDate);
        }
        clearReport();
    };
    useEffect(function() {
        dispatch(allShop(modalContextRef.current));
        return function() {
            dispatch(clearGetReportReservationPerformanceMonthly());
            dispatch(clearallShop());
        };
    }, [
        dispatch
    ]);
    useEffect(function() {
        if (allShopReducer.data && !allShopReducer.isError) {
            var data = allShopReducer.data.data;
            setShops(Array.isArray(data) ? data : []);
        }
    }, [
        allShopReducer
    ]);
    useEffect(function() {
        if (reportReducer.data && !reportReducer.isError) {
            var result = reportReducer.data.data || {};
            setRows(Array.isArray(result.data) ? result.data : []);
            setSummary(result.summary || EMPTY_SUMMARY);
            setHasSearched(true);
        }
        if (reportReducer.isError) {
            setRows([]);
            setSummary(EMPTY_SUMMARY);
            setHasSearched(false);
        }
    }, [
        reportReducer
    ]);
    var shopOptions = useMemo(function() {
        return shops.map(function(shop) {
            return {
                value: shop.sh_shop_id,
                label: shop.sh_shop_name || "ร้านค้า ".concat(shop.sh_shop_id)
            };
        });
    }, [
        shops
    ]);
    var branchOptions = useMemo(function() {
        var sourceShops = shopId ? shops.filter(function(shop) {
            return Number(shop.sh_shop_id) === Number(shopId);
        }) : shops;
        return sourceShops.flatMap(function(shop) {
            return (shop.shBranch || []).map(function(branch) {
                return {
                    value: branch.sh_branch_id,
                    label: shopId ? branch.sh_branch_name || "สาขา ".concat(branch.sh_branch_id) : "".concat(branch.sh_branch_name || "สาขา ".concat(branch.sh_branch_id), " (").concat(shop.sh_shop_name || "-", ")")
                };
            });
        });
    }, [
        shopId,
        shops
    ]);
    var handleSearch = function() {
        if (!startDate || !endDate) {
            clearReport();
            setError("กรุณาเลือกวันที่เริ่มต้นและวันที่สิ้นสุดให้ครบถ้วน");
            return;
        }
        if (moment(endDate).isBefore(moment(startDate), "day")) {
            clearReport();
            setError("วันที่สิ้นสุดต้องไม่น้อยกว่าวันที่เริ่มต้น");
            return;
        }
        setError("");
        setRows([]);
        setSummary(EMPTY_SUMMARY);
        setHasSearched(true);
        dispatch(getReportReservationPerformanceMonthly(_object_spread({
            sdate: moment(startDate).format("YYYY-MM-DD"),
            edate: moment(endDate).format("YYYY-MM-DD")
        }, shopId && {
            shopid: Number(shopId)
        }, branchId && {
            shbranchid: Number(branchId)
        }), modalContextRef.current));
    };
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "pagezoom",
                children: [
                    /*#__PURE__*/ _jsx("nav", {
                        "aria-label": "breadcrumb",
                        className: "mt-2",
                        children: /*#__PURE__*/ _jsxs("ol", {
                            className: "breadcrumb fs-16 ps-0 mb-1",
                            children: [
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("span", {
                                        className: "tc-7",
                                        children: "รายงาน"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item active",
                                    children: "รายงานสรุปประสิทธิภาพการทำงานรายเดือน"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "fs-24 mb-2",
                        children: "รายงานสรุปประสิทธิภาพการทำงานรายเดือน"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Card, {
                className: "card-st-3 mb-3",
                children: /*#__PURE__*/ _jsxs(CardBody, {
                    className: "px-xl-3",
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: "row gx-xl-4 align-items-end",
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: "col-xl-2 col-md-6",
                                    children: /*#__PURE__*/ _jsx(ReportDateRangeSelect, {
                                        value: dateRange,
                                        onChange: handleDateRangeChange
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "col-xl-2 col-md-6",
                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                        className: "mb-0 form-st-3 p-0",
                                        children: [
                                            /*#__PURE__*/ _jsxs(Form.Label, {
                                                className: "mb-1",
                                                children: [
                                                    "วันที่เริ่มต้น ",
                                                    /*#__PURE__*/ _jsx("span", {
                                                        className: "text-danger",
                                                        children: "*"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsx(DatePicker, {
                                                selected: startDate,
                                                onChange: function(date) {
                                                    setDateRange("custom");
                                                    setStartDate(date);
                                                    if (endDate && date && moment(endDate).isBefore(date, "day")) {
                                                        setEndDate(null);
                                                    }
                                                    clearReport();
                                                },
                                                dateFormat: "dd-MM-yyyy",
                                                className: "form-control px-2 mb-2 input-equal",
                                                placeholderText: "เลือกวันที่เริ่มต้น",
                                                maxDate: endDate,
                                                isClearable: true
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "col-xl-2 col-md-6",
                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                        className: "mb-0 form-st-3 p-0",
                                        children: [
                                            /*#__PURE__*/ _jsxs(Form.Label, {
                                                className: "mb-1",
                                                children: [
                                                    "วันที่สิ้นสุด ",
                                                    /*#__PURE__*/ _jsx("span", {
                                                        className: "text-danger",
                                                        children: "*"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsx(DatePicker, {
                                                selected: endDate,
                                                onChange: function(date) {
                                                    setDateRange("custom");
                                                    setEndDate(date);
                                                    clearReport();
                                                },
                                                dateFormat: "dd-MM-yyyy",
                                                className: "form-control px-2 mb-2 input-equal",
                                                placeholderText: "เลือกวันที่สิ้นสุด",
                                                minDate: startDate,
                                                isClearable: true
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "col-xl-3 col-md-6",
                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                        className: "mb-2 form-st-3",
                                        children: [
                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                className: "mb-1",
                                                children: "ค้นหาร้านค้า"
                                            }),
                                            /*#__PURE__*/ _jsx(Select, {
                                                className: "w-100 select-st-3",
                                                placeholder: loadingFilters ? "กำลังโหลด..." : "ค้นหาร้านค้า",
                                                options: shopOptions,
                                                value: shopOptions.find(function(item) {
                                                    return item.value === shopId;
                                                }) || null,
                                                onChange: function(option) {
                                                    setShopId((option === null || option === void 0 ? void 0 : option.value) || "");
                                                    setBranchId("");
                                                    clearReport();
                                                },
                                                isLoading: loadingFilters,
                                                isClearable: true
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "col-xl-3 col-md-6",
                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                        className: "mb-2 form-st-3",
                                        children: [
                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                className: "mb-1",
                                                children: "ค้นหาสาขา"
                                            }),
                                            /*#__PURE__*/ _jsx(Select, {
                                                className: "w-100 select-st-3",
                                                placeholder: loadingFilters ? "กำลังโหลด..." : "ค้นหาสาขา",
                                                options: branchOptions,
                                                value: branchOptions.find(function(item) {
                                                    return item.value === branchId;
                                                }) || null,
                                                onChange: function(option) {
                                                    setBranchId((option === null || option === void 0 ? void 0 : option.value) || "");
                                                    clearReport();
                                                },
                                                isLoading: loadingFilters,
                                                isClearable: true
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "col-xl-2 col-md-6",
                                    children: /*#__PURE__*/ _jsx(Button, {
                                        variant: "danger",
                                        className: "w-100 mb-2",
                                        onClick: handleSearch,
                                        disabled: loading,
                                        children: loading ? /*#__PURE__*/ _jsxs(_Fragment, {
                                            children: [
                                                /*#__PURE__*/ _jsx(Spinner, {
                                                    animation: "border",
                                                    size: "sm",
                                                    className: "me-2"
                                                }),
                                                "กำลังค้นหา"
                                            ]
                                        }) : "ค้นหา"
                                    })
                                })
                            ]
                        }),
                        error ? /*#__PURE__*/ _jsx(Alert, {
                            variant: "danger",
                            className: "mt-2 mb-0",
                            children: error
                        }) : null
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(Card, {
                className: "card-st-3 mb-3",
                children: /*#__PURE__*/ _jsx(CardBody, {
                    className: "p-0",
                    children: !hasSearched ? /*#__PURE__*/ _jsx("div", {
                        className: "text-center text-secondary py-5",
                        children: "กรุณาเลือกวันที่เริ่มต้นและวันที่สิ้นสุด แล้วกดค้นหา"
                    }) : /*#__PURE__*/ _jsx("div", {
                        className: "table-responsive",
                        children: /*#__PURE__*/ _jsxs(Table, {
                            bordered: true,
                            hover: true,
                            className: "align-middle mb-0 text-nowrap",
                            children: [
                                /*#__PURE__*/ _jsxs("thead", {
                                    className: "table-light",
                                    children: [
                                        /*#__PURE__*/ _jsxs("tr", {
                                            children: [
                                                /*#__PURE__*/ _jsx("th", {
                                                    rowSpan: 2,
                                                    className: "text-center align-middle",
                                                    children: "วันที่"
                                                }),
                                                /*#__PURE__*/ _jsx("th", {
                                                    colSpan: 5,
                                                    className: "text-center fs-18",
                                                    children: "จำนวนใบจอง"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsxs("tr", {
                                            children: [
                                                /*#__PURE__*/ _jsx("th", {
                                                    className: "text-center",
                                                    children: "วันที่เซลล์ยืนยัน"
                                                }),
                                                /*#__PURE__*/ _jsx("th", {
                                                    className: "text-center",
                                                    children: "กำลังจัดสินค้า"
                                                }),
                                                /*#__PURE__*/ _jsx("th", {
                                                    className: "text-center",
                                                    children: "ตรวจสอบสินค้า"
                                                }),
                                                /*#__PURE__*/ _jsx("th", {
                                                    className: "text-center",
                                                    children: "รอส่งสินค้า"
                                                }),
                                                /*#__PURE__*/ _jsx("th", {
                                                    className: "text-center",
                                                    children: "ส่งสินค้าแล้ว"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsx("tbody", {
                                    children: rows.map(function(row) {
                                        return /*#__PURE__*/ _jsxs("tr", {
                                            children: [
                                                /*#__PURE__*/ _jsx("td", {
                                                    className: "fw-semibold text-center",
                                                    children: moment.utc(row.date).format("DD/MM/YYYY")
                                                }),
                                                /*#__PURE__*/ _jsx("td", {
                                                    className: countClassName(row.sale_confirmed),
                                                    children: numberText(row.sale_confirmed)
                                                }),
                                                /*#__PURE__*/ _jsx("td", {
                                                    className: countClassName(row.organizing),
                                                    children: numberText(row.organizing)
                                                }),
                                                /*#__PURE__*/ _jsx("td", {
                                                    className: countClassName(row.product_checked),
                                                    children: numberText(row.product_checked)
                                                }),
                                                /*#__PURE__*/ _jsx("td", {
                                                    className: countClassName(row.waiting_delivery),
                                                    children: numberText(row.waiting_delivery)
                                                }),
                                                /*#__PURE__*/ _jsx("td", {
                                                    className: countClassName(row.delivered),
                                                    children: numberText(row.delivered)
                                                })
                                            ]
                                        }, row.date);
                                    })
                                }),
                                /*#__PURE__*/ _jsx("tfoot", {
                                    className: "table-light fw-bold",
                                    children: /*#__PURE__*/ _jsxs("tr", {
                                        children: [
                                            /*#__PURE__*/ _jsx("td", {
                                                className: "text-center",
                                                children: "รวม"
                                            }),
                                            /*#__PURE__*/ _jsx("td", {
                                                className: countClassName(summary.sale_confirmed),
                                                children: numberText(summary.sale_confirmed)
                                            }),
                                            /*#__PURE__*/ _jsx("td", {
                                                className: countClassName(summary.organizing),
                                                children: numberText(summary.organizing)
                                            }),
                                            /*#__PURE__*/ _jsx("td", {
                                                className: countClassName(summary.product_checked),
                                                children: numberText(summary.product_checked)
                                            }),
                                            /*#__PURE__*/ _jsx("td", {
                                                className: countClassName(summary.waiting_delivery),
                                                children: numberText(summary.waiting_delivery)
                                            }),
                                            /*#__PURE__*/ _jsx("td", {
                                                className: countClassName(summary.delivered),
                                                children: numberText(summary.delivered)
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    })
                })
            })
        ]
    });
}
